/**
 * Mechanism that lets the devtools `triggerError('render-crash')` command force a
 * React render-time throw. We need a real render error (not just a thrown
 * promise) to verify that the outer `Sentry.ErrorBoundary` correctly
 * captures the React component stack.
 */

import { RenderErrorListener } from '../types/RenderErrorListener';

const listeners = new Set<RenderErrorListener>();

export const subscribeToRenderError = (
  listener: RenderErrorListener,
): (() => void) => {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
};

export const triggerRenderError = (message: string): void => {
  listeners.forEach((listener): void => {
    listener(message);
  });
};
